import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <p className="footer-text">Copyright &copy; 2020 Sleuth TV</p>
    </footer>
  );
};

export default Footer;
